module.exports = __webpack_public_path__ + "static/media/23004561_1638429052898946_6397879881270714577_o-thumb.57373c1e.jpg";